import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0aeda39c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = {
  class: "table align-middle table-row-dashed fs-6 gy-5",
  id: "table_accounts_requests"
}
const _hoisted_6 = { class: "text-start text-muted fw-bold fs-7 text-uppercase gs-0" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "" }, "id", -1))
const _hoisted_8 = { class: "" }
const _hoisted_9 = { class: "" }
const _hoisted_10 = { class: "" }
const _hoisted_11 = { class: "" }
const _hoisted_12 = { class: "" }
const _hoisted_13 = { class: "" }
const _hoisted_14 = { class: "text-center min-w-150px" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = {
  key: 2,
  class: "fw-semibold text-gray-900"
}
const _hoisted_18 = { class: "text-center" }
const _hoisted_19 = {
  class: "card-title",
  style: {"font-weight":"500"}
}
const _hoisted_20 = { class: "table align-middle table-row-dashed fs-6 gy-5" }
const _hoisted_21 = { class: "text-start text-muted fw-bold fs-7 text-uppercase gs-0" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "" }, "id", -1))
const _hoisted_23 = { class: "" }
const _hoisted_24 = { class: "" }
const _hoisted_25 = { class: "" }
const _hoisted_26 = { class: "" }
const _hoisted_27 = { class: "" }
const _hoisted_28 = { class: "" }
const _hoisted_29 = { class: "text-center min-w-150px" }
const _hoisted_30 = { key: 0 }
const _hoisted_31 = { key: 1 }
const _hoisted_32 = {
  key: 2,
  class: "fw-semibold text-gray-900"
}
const _hoisted_33 = { class: "text-center" }

import TableFooter from "@/components/TableFooter.vue";
import { ref, onMounted } from "vue";
import { ArrowDown } from "@element-plus/icons-vue";
import UserService from "../services/UserService";
import { ServiceToPlatform } from "@/core/types/ServiceTypes";
import OpenProcedureForm from "../../accounts/components/OpenProcedureForm.vue";
import MsgPrompt from "@/core/plugins/MsgPrompt";

import AccountDetail from "@/projects/tenant/modules/accounts/components/AccountDetail.vue";
import { ElNotification, ElMessageBox } from "element-plus";
import i18n from "@/core/plugins/i18n";
import { is } from "@vee-validate/rules";


export default /*#__PURE__*/_defineComponent({
  __name: 'UserAccounts',
  props: {
    partyId: {}
  },
  setup(__props: any) {

const props = __props;

const t = i18n.global.t;
const accountDetailRef = ref<InstanceType<typeof AccountDetail>>();
const criteria = ref({
  size: 100,
});


const isLoading = ref(true);
const userAccounts = ref(Array<any>());
const demoAccounts = ref(Array<any>());
const openProcedureFormRef = ref<InstanceType<typeof OpenProcedureForm>>();
const accountCriteria = ref({
  partyId: props.partyId,
  page: 1,
  size: 10,
} as any);
const demoCriteria = ref({
  page: 1,
  size: 10,
  partyId: props.partyId,
});
const procedureFormRef = ref<InstanceType<typeof OpenProcedureForm>>();

onMounted(async () => {
  isLoading.value = true;
  await getUserAccounts(accountCriteria.value.page);
  await fetchDataDemo(1);
  isLoading.value = false;
});

const getUserAccounts = async (selectedPage: number) => {
  isLoading.value = true;
  try {
    accountCriteria.value.page = selectedPage;
    const res = await UserService.queryUserAccounts(accountCriteria.value);
    accountCriteria.value = res.criteria;
    userAccounts.value = res.data;
  } catch (error) {
    console.log(error);
  }
  isLoading.value = false;
};

const fetchDataDemo = async (_page: number) => {
  demoCriteria.value.page = _page;
  try {
    const res = await UserService.queryDemoAccounts(demoCriteria.value);
    demoAccounts.value = res.data;
    demoCriteria.value = res.criteria;
  } catch (error) {
    console.log(error);
  }
};
const openConfirm = async (_item: any) => {
  ElMessageBox.confirm(t("tip.confirmPrompt"), {
    confirmButtonText: t("tip.confirm"),
    cancelButtonText: t("action.cancel"),
    type: "warning",
  }).then(() => {
    deleteDemoAccount(_item);
  });
};
const deleteDemoAccount = async (_item: any) => {
  isLoading.value = true;
  try {
    await UserService.deleteDemoAccount(_item.id);
    ElNotification({
      title: t("status.success"),
      type: "success",
    });
    fetchDataDemo(1);
  } catch (error) {
    ElNotification({
      message: t("tip.unexpectedError"),
      type: "error",
    });
  }
  isLoading.value = false;
};
const pageChange = (page: number) => {
  getUserAccounts(page);
};

const openMT4Account = async (accountId: number) => {
  const res = await UserService.queryApplications({
    referenceId: accountId,
  });
  if (res.data.length <= 0) {
    MsgPrompt.error("未找到相应的申请记录");
    return;
  }
  const applicationDetails = res.data[0];
  openProcedureFormRef.value?.show(2, { applicationDetails });
};

const showAccountDetail = (id: number) => {
  accountDetailRef.value?.show(id, "infos", [] as any);
};
const openOpenProcedureForm = (accountId: number) => {
  procedureFormRef.value?.show(accountId);
};

return (_ctx: any,_cache: any) => {
  const _component_LoadingRing = _resolveComponent("LoadingRing")!
  const _component_NoDataBox = _resolveComponent("NoDataBox")!
  const _component_TimeShow = _resolveComponent("TimeShow")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_BalanceShow = _resolveComponent("BalanceShow")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.$t("fields.existingAccounts")), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("table", _hoisted_5, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("th", _hoisted_8, _toDisplayString(_ctx.$t("fields.accountNumber")), 1),
              _createElementVNode("th", _hoisted_9, _toDisplayString(_ctx.$t("fields.uid")), 1),
              _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.$t("fields.accountRole")), 1),
              _createElementVNode("th", _hoisted_11, _toDisplayString(_ctx.$t("fields.salesAccount")), 1),
              _createElementVNode("th", _hoisted_12, _toDisplayString(_ctx.$t("fields.agentAccount")), 1),
              _createElementVNode("th", _hoisted_13, _toDisplayString(_ctx.$t("fields.createdOn")), 1),
              _createElementVNode("th", _hoisted_14, _toDisplayString(_ctx.$t("action.action")), 1)
            ])
          ]),
          (isLoading.value)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_15, [
                _createVNode(_component_LoadingRing)
              ]))
            : (!isLoading.value && userAccounts.value.length === 0)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_16, [
                  _createVNode(_component_NoDataBox)
                ]))
              : (_openBlock(), _createElementBlock("tbody", _hoisted_17, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(userAccounts.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("td", null, _toDisplayString(item.id), 1),
                      _createElementVNode("td", null, _toDisplayString(item.tradeAccount?.accountNumber ?? "***"), 1),
                      _createElementVNode("td", null, _toDisplayString(item.uid ?? "***"), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.$t(`type.accountRole.${item.role}`)), 1),
                      _createElementVNode("td", null, _toDisplayString(item.salesAccount?.user?.displayName), 1),
                      _createElementVNode("td", null, _toDisplayString(item.agentAccount?.user?.displayName), 1),
                      _createElementVNode("td", null, [
                        _createVNode(_component_TimeShow, {
                          "date-iso-string": item.createdOn
                        }, null, 8, ["date-iso-string"])
                      ]),
                      _createElementVNode("td", _hoisted_18, [
                        (!item.hasTradeAccount)
                          ? (_openBlock(), _createBlock(_component_el_dropdown, {
                              key: 0,
                              class: "me-3",
                              trigger: "click"
                            }, {
                              dropdown: _withCtx(() => [
                                _createVNode(_component_el_dropdown_menu, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_dropdown_item, {
                                      onClick: ($event: any) => (openMT4Account(item.id))
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t("title.createTradeAccount")), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"]),
                                    _createVNode(_component_el_dropdown_item, {
                                      onClick: ($event: any) => (openOpenProcedureForm(item.id)),
                                      disabled: ""
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t("tip.accountOpenProcedure")), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"]),
                                    _createVNode(_component_el_dropdown_item, { disabled: "" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t("tip.welcomeLetter")), 1)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_dropdown_item, { disabled: "" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t("tip.readOnlyNotice")), 1)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_dropdown_item, { disabled: "" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t("tip.kycForm")), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_el_button, { type: "primary" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t("action.openAccountActions")) + " ", 1),
                                    _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(ArrowDown))
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 2
                            }, 1024))
                          : (_openBlock(), _createBlock(_component_el_button, {
                              key: 1,
                              onClick: ($event: any) => (showAccountDetail(item.id))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t("action.details")), 1)
                              ]),
                              _: 2
                            }, 1032, ["onClick"]))
                      ])
                    ]))
                  }), 128))
                ]))
        ]),
        _createVNode(TableFooter, {
          onPageChange: pageChange,
          criteria: accountCriteria.value
        }, null, 8, ["criteria"]),
        _createElementVNode("div", null, [
          _createVNode(_component_el_divider),
          _createElementVNode("h3", _hoisted_19, _toDisplayString(_ctx.$t("title.demoAccounts")), 1),
          _createElementVNode("table", _hoisted_20, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", _hoisted_21, [
                _hoisted_22,
                _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.accountNo")), 1),
                _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.platform")), 1),
                _createElementVNode("th", _hoisted_23, _toDisplayString(_ctx.$t("fields.type")), 1),
                _createElementVNode("th", _hoisted_24, _toDisplayString(_ctx.$t("fields.currency")), 1),
                _createElementVNode("th", _hoisted_25, _toDisplayString(_ctx.$t("fields.balance")), 1),
                _createElementVNode("th", _hoisted_26, _toDisplayString(_ctx.$t("fields.leverage")), 1),
                _createElementVNode("th", _hoisted_27, _toDisplayString(_ctx.$t("fields.createdOn")), 1),
                _createElementVNode("th", _hoisted_28, _toDisplayString(_ctx.$t("fields.expireDate")), 1),
                _createElementVNode("th", _hoisted_29, _toDisplayString(_ctx.$t("action.action")), 1)
              ])
            ]),
            (isLoading.value)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_30, [
                  _createVNode(_component_LoadingRing)
                ]))
              : (!isLoading.value && demoAccounts.value.length === 0)
                ? (_openBlock(), _createElementBlock("tbody", _hoisted_31, [
                    _createVNode(_component_NoDataBox)
                  ]))
                : (_openBlock(), _createElementBlock("tbody", _hoisted_32, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(demoAccounts.value, (item, index) => {
                      return (_openBlock(), _createElementBlock("tr", { key: index }, [
                        _createElementVNode("td", null, _toDisplayString(item.id), 1),
                        _createElementVNode("td", null, _toDisplayString(item.accountNumber), 1),
                        _createElementVNode("td", null, _toDisplayString(_unref(ServiceToPlatform)[item.serviceId]), 1),
                        _createElementVNode("td", null, _toDisplayString(item?.type ? _ctx.$t(`type.account.${item?.type}`) : "***"), 1),
                        _createElementVNode("td", null, _toDisplayString(item?.currencyId
                    ? _ctx.$t(`type.currency.${item?.currencyId}`)
                    : "***"), 1),
                        _createElementVNode("td", null, [
                          _createVNode(_component_BalanceShow, {
                            balance: item.balance * 100
                          }, null, 8, ["balance"])
                        ]),
                        _createElementVNode("td", null, _toDisplayString(item?.leverage ? item?.leverage + ":1" : "***"), 1),
                        _createElementVNode("td", null, [
                          _createVNode(_component_TimeShow, {
                            "date-iso-string": item.createdOn
                          }, null, 8, ["date-iso-string"])
                        ]),
                        _createElementVNode("td", null, [
                          _createVNode(_component_TimeShow, {
                            "date-iso-string": item.expireOn
                          }, null, 8, ["date-iso-string"])
                        ]),
                        _createElementVNode("td", _hoisted_33, [
                          _createVNode(_component_el_button, {
                            type: "danger",
                            onClick: ($event: any) => (openConfirm(item)),
                            disabled: isLoading.value
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("action.delete")), 1)
                            ]),
                            _: 2
                          }, 1032, ["onClick", "disabled"])
                        ])
                      ]))
                    }), 128))
                  ]))
          ]),
          _createVNode(TableFooter, {
            onPageChange: fetchDataDemo,
            criteria: demoCriteria.value
          }, null, 8, ["criteria"])
        ]),
        _createVNode(OpenProcedureForm, {
          ref_key: "openProcedureFormRef",
          ref: openProcedureFormRef,
          onStepFinished: _cache[0] || (_cache[0] = ($event: any) => (getUserAccounts(1)))
        }, null, 512)
      ])
    ]),
    _createElementVNode("div", null, [
      _createVNode(AccountDetail, {
        ref_key: "accountDetailRef",
        ref: accountDetailRef
      }, null, 512)
    ])
  ], 64))
}
}

})